import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';

export const useCreatePost = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ content, visibility = 'public' }: { content: string; visibility?: string }) => {
      if (!user) {
        throw new Error('User must be authenticated to create a post');
      }

      const { data, error } = await supabase
        .from('posts')
        .insert({
          content,
          user_id: user.id,
          visibility,
        })
        .select(`
          id,
          content,
          created_at,
          user_id,
          visibility,
          profiles!inner (
            full_name,
            belt_rank,
            profile_picture_url
          )
        `)
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['posts'] });
    },
  });
}; 